import { call, put, takeLatest } from 'redux-saga/effects';
import { LOAD_DATA } from './constants';
import { loadDataSuccess, loadDataError } from './actions';
import { fetchError, fetchStart, fetchEnd } from 'containers/App/actions';
import request from 'utils/request';
import { stringify } from 'qs';

export function* getData({ payload = {} }) {
  let requestURL = `apps`;

  try {
    yield put(fetchStart());

    const query = stringify(
      {
        p: payload.page,
        l: payload.sizePerPage,
      },
      { addQueryPrefix: true },
    );

    const resp = yield call(request, requestURL + query);
    let data = {};
    if (resp.json) {
      data = resp.json;
    }
    yield put(loadDataSuccess(data));
    yield put(fetchEnd());
  } catch (err) {
    yield put(loadDataError(err));
    yield put(fetchError(err));
  }
}

export default function* main() {
  yield takeLatest(LOAD_DATA, getData);
}
